import {Text} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'
import SandwichInformationList from '../../SandwichInformationList'
import {CogIcon, CommentIcon} from '../../../icons'

const ExpenseAccountSandwichList = () => {
  const {t} = useTranslation('connectExpenseAccount')

  const sandwichInformationListData = [
    {
      key: 'info',
      icon: CommentIcon,
      description: (
        <Text fontWeight="medium" fontSize="sm" lineHeight="125%">
          {t('modal.information.sandwichList.info.description')}
        </Text>
      ),
      extendedDescription: (
        <Text fontSize="sm" lineHeight="125%">
          {t('modal.information.sandwichList.info.extendedDescription')}
        </Text>
      ),
    },
    {
      key: 'settings',
      icon: CogIcon,
      description: (
        <Text fontWeight="medium" fontSize="sm" lineHeight="125%">
          {t('modal.information.sandwichList.settings.description')}
        </Text>
      ),
      extendedDescription: (
        <Text fontSize="sm" lineHeight="125%">
          {t('modal.information.sandwichList.settings.extendedDescription')}
        </Text>
      ),
    },
  ]

  return (
    <SandwichInformationList
      data-testid="expense-account-sandwich-info-list"
      data={sandwichInformationListData}
    />
  )
}

export default ExpenseAccountSandwichList
